import { H5 } from 'foundations-components/transitional/components/H5';
import styled from 'academy-common-lib/utils/Styling';
import { Logo } from 'foundations-components/transitional/components/Logo';
import { getShareLinks } from 'academy-common-lib/utils/url';
import { getProxyUrl } from 'academy-common-lib/utils/url';
import { useLocation } from 'react-router-dom';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ShareSection = styled.section.withConfig({
  displayName: "PublicPageShareSection__ShareSection"
})(["text-align:center;padding:32px 0;"]);
const PublicPageShareSection = ({
  contentType
}) => {
  const location = useLocation();
  const {
    linkForX,
    linkForFacebook,
    linkForLinkedIn
  } = getShareLinks(getProxyUrl(location.pathname));
  return /*#__PURE__*/_jsxs(ShareSection, {
    "data-test-id": "public-page-share-section",
    children: [/*#__PURE__*/_jsx(H5, {
      children: contentType === 'LESSON' ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.share.lesson"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.share.course"
      })
    }), /*#__PURE__*/_jsx("a", {
      "aria-label": I18n.text('academyPublic.share.facebookLogo'),
      href: linkForFacebook,
      children: /*#__PURE__*/_jsx(Logo, {
        height: 36,
        marginInlineEnd: "200",
        name: "facebook",
        width: 36
      })
    }), /*#__PURE__*/_jsx("a", {
      "aria-label": I18n.text('academyPublic.share.linkedinLogo'),
      href: linkForLinkedIn,
      children: /*#__PURE__*/_jsx(Logo, {
        height: 36,
        marginInlineEnd: "200",
        name: "linkedin",
        width: 36
      })
    }), /*#__PURE__*/_jsx("a", {
      "aria-label": I18n.text('academyPublic.share.xLogo'),
      href: linkForX,
      children: /*#__PURE__*/_jsx(Logo, {
        height: 36,
        name: "x-social",
        width: 36
      })
    })]
  });
};
export default PublicPageShareSection;